import { render, staticRenderFns } from "./LightCandle.vue?vue&type=template&id=02c542ba&scoped=true&"
import script from "./LightCandle.vue?vue&type=script&lang=js&"
export * from "./LightCandle.vue?vue&type=script&lang=js&"
import style0 from "./LightCandle.vue?vue&type=style&index=0&id=02c542ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c542ba",
  null
  
)

export default component.exports